import { PlatformDependent } from '@/components/PlatformDependent'

import { LicensesViewDDE } from './LicensesView.dde'
import { LicensesViewDGE } from './LicensesView.dge'

const LicensesView = () => (
  <>
    <PlatformDependent dde>
      <LicensesViewDDE />
    </PlatformDependent>
    <PlatformDependent streaming>
      <LicensesViewDGE />
    </PlatformDependent>
  </>
)

export default LicensesView
